import Card from '@material-ui/core/Card'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Typography from '../base/Typography'

export type TotalAdjustmentCardProps = {
  label?: string
  amount?: number
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      /* Color / Base 2 */
      background: '#32C27D',
      color: theme.palette.common.white,
      minWidth: theme.spacing(20),
      maxWidth: '100%',
      borderRadius: 8,
      display: 'grid',
      gridGap: theme.spacing(0.5),
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`
    }
  })
)

const TotalAdjustmentCard: React.FC<TotalAdjustmentCardProps> = (props) => {
  const { label = 'Total', amount = 0 } = props
  const classes = useStyles()
  return (
    <Card elevation={0} classes={{ root: classes.card }}>
      <Typography bodyVariants="xsMedium" children={label} />
      <Typography variant="h4" children={'$' + amount} />
    </Card>
  )
}

export default TotalAdjustmentCard
